<template>
  <v-footer class="pt-3 myfooter bblue-grey lighten-5 pa-0">
    <v-spacer></v-spacer>    
    <p class="caption px-3">
      Copyright Tecisa &copy; {{ new Date().getFullYear() }} Todos los derechos reservados
      <span class="">- Claudio Coello, 51, 28001 Madrid</span>
    </p>
  </v-footer>
</template>



<script>
  export default {};
</script>

<style>
  footer{
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>